import '@/styles/under-construction.css'
import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

define('UnderConstructionPage', () =>
    h('div', { className: 'page page--construction' },
        c('Header'),
        h('div', { className: 'uc' },
            h('div', { className: 'uc__inner' },
                h('div', { className: 'uc__icon' }, '🚧'),
                h('h1',  { className: 'uc__title' }, 'Página en construcción'),
                h('p',   { className: 'uc__desc' },
                    'Esta sección estará disponible muy pronto. ' +
                    'Mientras tanto, puedes explorar el directorio de negocios de Fusagasugá.'),
                h('a', { href: '/', className: 'uc__btn' }, '← Volver al inicio')
            )
        ),
        c('Footer')
    )
)
